import { createSlice } from '@reduxjs/toolkit';
import companyConfigs from '../Components/AutoDetection/config';

// Fallback company when company config is not found
const FALLBACK_COMPANY = 'toothlens';

const initialState = {
    company: null,
    config: null,
    isLoading: false,
    error: null
};

const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        setCompany: (state, action) => {
            const companyName = action.payload;
            state.company = companyName;
            state.isLoading = true;
            state.error = null;

            try {
                const companyConfig = companyConfigs[companyName];
                if (companyConfig) {
                    state.config = companyConfig;
                    // Store in localStorage for any legacy code that might need it
                    localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: companyName }));
                } else {
                    // Fallback to default company if company not found
                    state.config = companyConfigs[FALLBACK_COMPANY];
                    state.company = FALLBACK_COMPANY;
                    localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: FALLBACK_COMPANY }));
                }
                state.isLoading = false;
            } catch (error) {
                state.error = error.message;
                state.isLoading = false;
                // Fallback to default company on error
                state.config = companyConfigs[FALLBACK_COMPANY];
                state.company = FALLBACK_COMPANY;
            }
        },
        clearCompany: (state) => {
            state.company = null;
            state.config = null;
            state.error = null;
            state.isLoading = false;
        },
        initializeCompanyFromStorage: (state) => {
            try {
                const storedCompany = localStorage.getItem("companyBucket");
                if (storedCompany) {
                    const { companyBucket } = JSON.parse(storedCompany);
                    const companyConfig = companyConfigs[companyBucket];
                    if (companyConfig) {
                        state.company = companyBucket;
                        state.config = companyConfig;
                    } else {
                        // Fallback to default company
                        state.company = FALLBACK_COMPANY;
                        state.config = companyConfigs[FALLBACK_COMPANY];
                    }
                } else {
                    // Ultimate fallback to default company
                    state.company = FALLBACK_COMPANY;
                    state.config = companyConfigs[FALLBACK_COMPANY];
                }
            } catch (error) {
                state.error = error.message;
                // Ultimate fallback to default company
                state.company = FALLBACK_COMPANY;
                state.config = companyConfigs[FALLBACK_COMPANY];
            }
        }
    }
});

export const { setCompany, clearCompany, initializeCompanyFromStorage } = companySlice.actions;

export default companySlice.reducer;